import _toConsumableArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useState } from 'react';
import { usePopper } from 'react-popper';
import { getDefaultZIndex } from '@mantine/styles';
import { useDidUpdate } from '@mantine/hooks';
import { parsePopperPosition } from './parse-popper-position/parse-popper-position.js';
import { PopperContainer } from './PopperContainer/PopperContainer.js';
import useStyles from './Popper.styles.js';
import { Transition } from '../Transition/Transition.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

function flipPlacement(placement, dir) {
  if (placement === "center") {
    return placement;
  }

  if (dir === "rtl") {
    if (placement === "end") {
      return "start";
    }

    return "end";
  }

  return placement;
}

function flipPosition(position, dir) {
  if (position === "top" || position === "bottom") {
    return position;
  }

  if (dir === "rtl") {
    if (position === "left") {
      return "right";
    }

    return "left";
  }

  return position;
}

function Popper(_ref) {
  var _ref$position = _ref.position,
      position = _ref$position === void 0 ? "top" : _ref$position,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? "center" : _ref$placement,
      _ref$gutter = _ref.gutter,
      gutter = _ref$gutter === void 0 ? 5 : _ref$gutter,
      _ref$arrowSize = _ref.arrowSize,
      arrowSize = _ref$arrowSize === void 0 ? 2 : _ref$arrowSize,
      _ref$arrowDistance = _ref.arrowDistance,
      arrowDistance = _ref$arrowDistance === void 0 ? 2 : _ref$arrowDistance,
      _ref$withArrow = _ref.withArrow,
      withArrow = _ref$withArrow === void 0 ? false : _ref$withArrow,
      referenceElement = _ref.referenceElement,
      children = _ref.children,
      mounted = _ref.mounted,
      _ref$transition = _ref.transition,
      transition = _ref$transition === void 0 ? "pop-top-left" : _ref$transition,
      transitionDuration = _ref.transitionDuration,
      _ref$exitTransitionDu = _ref.exitTransitionDuration,
      exitTransitionDuration = _ref$exitTransitionDu === void 0 ? transitionDuration : _ref$exitTransitionDu,
      transitionTimingFunction = _ref.transitionTimingFunction,
      arrowClassName = _ref.arrowClassName,
      arrowStyle = _ref.arrowStyle,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? getDefaultZIndex("popover") : _ref$zIndex,
      _ref$forceUpdateDepen = _ref.forceUpdateDependencies,
      forceUpdateDependencies = _ref$forceUpdateDepen === void 0 ? [] : _ref$forceUpdateDepen,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? [] : _ref$modifiers,
      onTransitionEnd = _ref.onTransitionEnd,
      _ref$withinPortal = _ref.withinPortal,
      withinPortal = _ref$withinPortal === void 0 ? true : _ref$withinPortal;

  var _a;

  var padding = withArrow ? gutter + arrowSize : gutter;

  var _useStyles = useStyles({
    arrowSize: arrowSize,
    arrowDistance: arrowDistance
  }, {
    name: "Popper"
  }),
      classes = _useStyles.classes,
      cx = _useStyles.cx,
      theme = _useStyles.theme;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      popperElement = _useState2[0],
      setPopperElement = _useState2[1];

  var _placement = flipPlacement(placement, theme.dir);

  var _position = flipPosition(position, theme.dir);

  var initialPlacement = _placement === "center" ? _position : "".concat(_position, "-").concat(_placement);

  var _usePopper = usePopper(referenceElement, popperElement, {
    placement: initialPlacement,
    modifiers: [{
      name: "offset",
      options: {
        offset: [0, padding]
      }
    }].concat(_toConsumableArray(modifiers))
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      forceUpdate = _usePopper.forceUpdate;

  var parsedAttributes = parsePopperPosition((_a = attributes.popper) == null ? void 0 : _a["data-popper-placement"]);
  useDidUpdate(function () {
    typeof forceUpdate === "function" && forceUpdate();
  }, forceUpdateDependencies);
  return /* @__PURE__ */React.createElement(Transition, {
    mounted: mounted && !!referenceElement,
    duration: transitionDuration,
    exitDuration: exitTransitionDuration,
    transition: transition,
    timingFunction: transitionTimingFunction,
    onExited: onTransitionEnd
  }, function (transitionStyles) {
    return /* @__PURE__ */React.createElement("div", null, /* @__PURE__ */React.createElement(PopperContainer, {
      withinPortal: withinPortal,
      zIndex: zIndex
    }, /* @__PURE__ */React.createElement("div", __spreadValues({
      ref: setPopperElement,
      style: __spreadProps(__spreadValues({}, styles.popper), {
        pointerEvents: "none"
      })
    }, attributes.popper), /* @__PURE__ */React.createElement("div", {
      style: transitionStyles
    }, children, withArrow && /* @__PURE__ */React.createElement("div", {
      style: arrowStyle,
      className: cx(classes.arrow, classes[parsedAttributes.placement], classes[parsedAttributes.position], arrowClassName)
    })))));
  });
}

Popper.displayName = "@mantine/core/Popper";
export { Popper };